import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { useNavigation } from "@react-navigation/native"
import React, { useContext } from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"

/**
 * « Formation » — the home card of a new tutor: the training video, then the
 * validation quiz. Shown while the server says so (`training_videos.required`:
 * no real live yet, quiz not passed), gone once the quiz is passed.
 */
function TrainingCompletionCard({ task }) {
    const navigation = useNavigation()
    const dimensions = useContext(DimensionsContext)

    if (!task?.required) return null

    const resuming = task.status === "failed"

    return (
        <View
            style={{
                width: dimensions?.width - 20,
                marginTop: 20,
                padding: 20,
                borderRadius: 15,
                borderWidth: 1,
                borderColor: theme.colors.lightMore,
                backgroundColor: theme.colors.white,
            }}
        >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
                <FontAwesome5
                    name="graduation-cap"
                    size={20}
                    color={theme.colors.primary}
                    style={{ marginRight: 10 }}
                />
                <TextM
                    fontWeight="Bold"
                    fontSize={20}
                    wrap
                    color={theme.colors.primary}
                >
                    Formation
                </TextM>
            </View>
            <TextM wrap style={{ marginTop: 10 }}>
                {resuming
                    ? "Tu y es presque ! Revois les points qui t'ont manqué et repasse le quiz quand tu te sens prêt·e."
                    : "Avant ton premier cours, regarde la vidéo de formation puis valide un petit quiz de 20 questions. Tout ce qu'il faut savoir pour bien démarrer."}
            </TextM>
            <FilledButtonM
                color={theme.colors.primary}
                label={resuming ? "Reprendre" : "Commencer"}
                icon="play-circle"
                style={{
                    width: null,
                    alignSelf: "flex-start",
                    marginTop: 16,
                    paddingHorizontal: 12,
                }}
                onPress={() => navigation.push("tutor/formation")}
            />
        </View>
    )
}

const mapStateToProps = (state) => ({
    task: state.data.tutors?.tasks?.training_videos,
})

export default connect(mapStateToProps)(TrainingCompletionCard)
